import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  OnDestroy,
} from "@angular/core";
import {
  ControlValueAccessor,
  FormBuilder,
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { Subscription } from "rxjs";

@Component({
  selector: "workforce-contact-details",
  templateUrl: "workforce-contact-details.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WorkforceContactDetails),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => WorkforceContactDetails),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkforceContactDetails
  implements ControlValueAccessor, OnDestroy
{
  innerFormGroup: FormGroup;
  subscriptions: Subscription[] = [];

  get value(): any {
    return this.innerFormGroup.value;
  }

  set value(value: any) {
    this.innerFormGroup.patchValue(value);
    this.onChange(value);
    this.onTouched();
  }

  constructor(protected formBuilder: FormBuilder) {
    // this.innerFormGroup = this.formBuilder.group({
    // });
    //
    // this.subscriptions.push(
    //     this.innerFormGroup.valueChanges.subscribe(value => {
    //         this.onChange(value);
    //         this.onTouched();
    //     })
    // );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onChange: any = (value) => {};
  onTouched: any = () => {};

  registerOnChange(fn) {
    this.onChange = fn;
  }

  writeValue(value) {
    if (value) {
      this.value = value;
    }

    if (value === null) {
      this.innerFormGroup.reset();
    }
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  validate(_: FormControl) {}

  reset() {
    this.innerFormGroup.reset();
  }
}



// WEBPACK FOOTER //
// ./src/components/system-admin/workforce/workforce-contact-details/workforce-contact-details.ts